import React, { useState } from 'react';
import axios from 'axios';
import { getApiBase } from '../utils/api';

export default function LinkedSignInOptions({ organizationId }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const link = async provider => {
    setError(''); setBusy(true);
    try {
      const response = await axios.get(`${getApiBase()}/auth/${provider}/url`, {
        params: { organization_id: organizationId, link: true }, withCredentials: true,
      });
      window.location.assign(response.data.auth_url);
    } catch (error) {
      setError(error.response?.data?.detail || 'Unable to start account linking.');
      setBusy(false);
    }
  };
  return <div>
    <h4 className="text-sm font-medium text-slate-700 mb-2">Additional sign-in methods</h4>
    <p className="text-sm text-slate-600 mb-3">Link your Google or Microsoft account after signing in with your existing method within the last 10 minutes. Use the same email address.</p>
    <div className="flex gap-3">
      <button disabled={busy} onClick={() => link('google')} className="px-4 py-2 border rounded-lg disabled:opacity-50">Link Google</button>
      <button disabled={busy} onClick={() => link('microsoft')} className="px-4 py-2 border rounded-lg disabled:opacity-50">Link Microsoft</button>
    </div>
    {error && <p role="alert" className="text-red-600 text-sm mt-2">{error}</p>}
  </div>;
}
